<template>
  <v-breadcrumbs class="manage-bread-crumb__breadcrumb" :items="breadcrumbItems" large dark>
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item :to="item.to" active-class="none">
        {{ item.text }}
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</template>

<script>
import updatePageTitle from '@/config/updatePageTitle';

export default {
  computed: {
    breadcrumbItems() {
      return (
        this.$route.meta.breadcrumbs &&
        this.$route.meta.breadcrumbs.map(breadcrumb => ({
          ...breadcrumb,
          text: breadcrumb.text
        }))
      );
    },
    updatedTitle() {
      const title = this.$route.meta.title;
      return updatePageTitle(title);
    }
  },
  watch: {
    updatedTitle(title) {
      document.title = title;
    }
  },
  mounted() {
    document.title = this.updatedTitle;
  }
};
</script>

<style lang="scss" scoped></style>
